/**
 * The new-order "ring".
 *
 * Synthesised with the Web Audio API rather than shipping an mp3, so there is
 * no asset to host and it works offline. Two rising chimes, repeated - close
 * enough to a shop counter bell to be noticed from across the room.
 */

let audioContext = null;

function context() {
  if (!audioContext) {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    audioContext = new Ctx();
  }
  // Browsers suspend the context until the page has been interacted with.
  if (audioContext.state === 'suspended') audioContext.resume();
  return audioContext;
}

function chime(ctx, startAt, frequency, duration = 0.4) {
  const oscillator = ctx.createOscillator();
  const gain = ctx.createGain();

  oscillator.type = 'sine';
  oscillator.frequency.setValueAtTime(frequency, startAt);

  gain.gain.setValueAtTime(0, startAt);
  gain.gain.linearRampToValueAtTime(0.35, startAt + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.001, startAt + duration);

  oscillator.connect(gain).connect(ctx.destination);
  oscillator.start(startAt);
  oscillator.stop(startAt + duration);
}

/** Plays the order alert. `repeats` doubles the two-note pattern. */
export function playRing(repeats = 2) {
  const ctx = context();
  if (!ctx) return;

  const now = ctx.currentTime;
  for (let i = 0; i < repeats; i += 1) {
    const offset = now + i * 0.62;
    chime(ctx, offset, 880);        // A5
    chime(ctx, offset + 0.18, 1174); // D6
  }
}

/** A single soft blip for status updates - deliberately less attention-grabbing. */
export function playBlip() {
  const ctx = context();
  if (!ctx) return;
  chime(ctx, ctx.currentTime, 660, 0.16);
}

/** Called once after the first click so the browser lets us play sound later. */
export function unlockAudio() {
  const ctx = context();
  if (ctx && ctx.state === 'suspended') ctx.resume();
}

const RING_PREF = 'uc_ring_enabled';
export const isRingEnabled = () => localStorage.getItem(RING_PREF) !== 'false';
export const setRingEnabled = (on) => localStorage.setItem(RING_PREF, String(on));
